const ServiceListingData = [
  {
    id: "01",
    serviceIcon: "lnr lnr-laptop-phone",
    serviceName: "Web Design",
    serviceDescription:
      "Browse our various templates and pick the one you like and use to build your website.",
    serviceUrl: "/services/webDesign",
  },
  {
    id: "02",
    serviceIcon: "lnr lnr-code",
    serviceName: "Web Development",
    serviceDescription:
      "Get a mind-blowing website for your business or services and take your business on air.",
    serviceUrl: "/services/webAppDevelopment",
  },
  {
    id: "03",
    serviceIcon: "lnr lnr-tablet",
    serviceName: "UI / UX",
    serviceDescription:
      "Quality UI and UX design from us helps bring efficiency and functionality together.",
    serviceUrl: "/services/uiUxDesign",
  },
  {
    id: "04",
    serviceIcon: "lnr lnr-leaf",
    serviceName: "Graphic Design",
    serviceDescription:
      "Keeping your Branding and overall marketing up to speed with what your clients/customers expect to see.",
    serviceUrl: "/services/branding",
  },
  {
    id: "05",
    serviceIcon: "lnr lnr-linearicons",
    serviceName: "Logo Design",
    serviceDescription:
      "Our logo will serve as a tool for you to attract the right audience towards your business & get lasting impression at the very first glance.",
    serviceUrl: "/services/logoDesign",
  },
  {
    id: "06",
    serviceIcon: "lnr lnr-map",
    serviceName: "Pamphlets Design",
    serviceDescription:
      "As experts in design, we make the highest quality brochures, pamphlets, flyers you will ever come across, that'll probably grab the attention of the masses.",
    serviceUrl: "/services/branding",
  },
  {
    id: "07",
    serviceIcon: "lnr lnr-picture",
    serviceName: "Photo-Manipulation",
    serviceDescription:
      "Transform your stock photos into amazing, artful pieces of fantasy photo manipulation.",
    serviceUrl: "/contact-us",
  },
  {
    id: "08",
    serviceIcon: "lnr lnr-magic-wand",
    serviceName: "Photo Retouching & Enhancement",
    serviceDescription:
      "Perfectly meet requirements of a professional photographer who wants to save time or a beginner who wants images to be professionally edited.",
    serviceUrl: "/contact-us",
  },
  {
    id: "09",
    serviceIcon: "lnr lnr-book",
    serviceName: "Magazine / Book Cover Design",
    serviceDescription:
      "Make the best sale in the market with attractive book cover designs. Have a professional and eye-catching cover that will attract your targeted readers.",
    serviceUrl: "/services/stationeryDesign",
  },
  {
    id: "10",
    serviceIcon: "lnr lnr-bullhorn",
    serviceName: "Digital Marketing",
    serviceDescription:
      "Our services encompass a wide range of online marketing techniques, including pay-per-click advertising, social media marketing, and more. We can help you establish a strong online presence and connect with your audience in a meaningful way.",
    serviceUrl: "/contact-us",
  },
  {
    id: "11",
    serviceIcon: "lnr lnr-rocket",
    serviceName: "Search Engine Optimisation",
    serviceDescription:
      "Increase your online presence and generate more top-of-funnel leads. Potential clients can quickly locate your brand online using any device. Improve your long-term authority, boost qualified traffic, leads, and business with us.",
    serviceUrl: "/services/seo",
  },
  {
    id: "12",
    serviceIcon: "lnr lnr-film-play",
    serviceName: "Video Animation",
    serviceDescription:
      "Capture the attention of your target audience through high-impact animated video advertising. We are providing Animation, Video Ads, Opener Logo, Scene Enhancement, Business Portfolio, Doodle Animation and much more.",
    serviceUrl: "/services/videoAnimation",
  },
];

export default ServiceListingData;
